<template>
  <lavendla-select
    v-if="options.length || competenceCategoryTypeOptions.length"
    :id="id"
    v-model="competenceType"
    :class-name="className"
  >
    <template v-if="options.length" #options>
      <option disabled selected value="" v-text="emptyValue" />
      <option
        v-for="{ value: optionsValue, label } in options"
        :key="optionsValue"
        :value="optionsValue"
      >
        {{ label }}
      </option>
    </template>
    <template v-else-if="competenceCategoryTypeOptions.length" #options>
      <option disabled selected value="" v-text="emptyValue" />
      <optgroup
        v-for="competenceCategoryType in competenceCategoryTypeOptions"
        :key="`competence_type_${competenceCategoryType.id}`"
        :label="competenceCategoryType.label"
      >
        <option
          v-for="competenceArea in competenceCategoryType.items"
          :key="`competence_area_${competenceArea.id}`"
          :value="competenceArea.slug"
        >
          {{ competenceArea.label }}
        </option>
      </optgroup>
    </template>
  </lavendla-select>
</template>

<script>
import { mapState } from 'vuex';
import LavendlaSelect from './ui/LavendlaSelect.vue';

export default {
  name: 'CompetenceTypeSelect',

  components: {
    LavendlaSelect,
  },

  props: {
    id: {
      type: String,
      default: 'competence-type-select',
    },
    className: {
      type: String,
      default: '',
    },
    emptyValue: {
      type: String,
      default: '-- Vänligen välj --',
    },
    options: {
      type: Array,
      default: () => [],
    },
    contactType: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      competenceType: this.value,
    };
  },

  computed: {
    ...mapState('inquiryCompetenceAreas', ['competenceCategoryTypeOptions']),
  },

  watch: {
    competenceType(newValue) {
      this.$emit('change', newValue);
    },
    contactType() {
      this.loadCompetenceAreas();
    },
  },

  created() {
    this.loadCompetenceAreas();
  },

  methods: {
    async loadCompetenceAreas() {
      await this.$store.dispatch(
        'inquiryCompetenceAreas/getInquiryCompetenceCategoryTypeOptions',
        {
          type: this.contactType,
        }
      );
    },
  },
};
</script>
